<app-header/>

<router-outlet />

<ui-kit-svg-atlas></ui-kit-svg-atlas>
